import type { router as AppRouter } from "@/Router";

// router.tsx(및 @tanstack/react-router 전체)를 App.tsx 가 정적 import 하면 로그인
// 화면에서도 대시보드 라우트 전체가 번들에 딸려온다. router 를 lazy 청크로 분리하되,
// App.tsx 본문의 Cmd+,/서비스워커 알림 리스너처럼 라우터 마운트 여부와 무관하게 항상
// 등록돼 있어야 하는 effect 들이 router 인스턴스를 참조할 수 있도록 이 핸들을 경유한다.
// (타입만 참조하므로 이 파일 자체는 router.tsx 를 런타임 그래프에 끌어들이지 않는다.)

let current: typeof AppRouter | null = null;

/** router.tsx 모듈이 평가될 때(=router 청크가 로드될 때) 자신을 등록한다. */
export function setAppRouter(router: typeof AppRouter): void {
  current = router;
}

/** 라우터 청크가 아직 로드되지 않았으면 null. 호출부는 optional chaining 으로
 * 무시하면 된다 — 라우터가 없다는 건 대시보드가 아직 안 떴다는 뜻이라 no-op 이 맞다. */
export function getAppRouter(): typeof AppRouter | null {
  return current;
}
